import { reactive } from 'vue'

export const buyerState = reactive({
  firstName: '',
  lastName: '',
  email: '',
  termsAndConditions: false,
  marketingConsent: false,
  emailFocus: false
})
